import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';

import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import Login from './views/auth/Login';
import Dashboard from './views/dashboard/Dashboard';
import Configuracion from './views/configuracion/Configuracion';
import Asistencias from './views/asistencias/Asistencias';
import Venta from './views/ventas/Venta';
import Ventas from './views/ventas/Ventas';
import DetalleVenta from './views/ventas/DetalleVenta';
import Vuelta from './views/vueltas/Vuelta';
import Vueltas from './views/vueltas/Vueltas';
import Complementar from './views/vueltas/Complementar';
import LiquidarVueltas from './views/vueltas/LiquidarVueltas';
import Corte from './views/cortes/Corte';
import Cortes from './views/cortes/Cortes';
import Gasto from './views/gastos/Gasto';
import Gastos from './views/gastos/Gastos';
import Revision from './views/revisiones/Revision';

import NotFound from './components/routing/NotFound';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <Alert />
                <Routes>
                    <Route path="/" element={
                        <ValidateSession>
                            <Login />
                        </ValidateSession>
                    } />
                    <Route path="/dashboard" element={
                        <PrivateRoute>
                            <Layout>
                                <Dashboard />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/venta" element={
                        <PrivateRoute>
                            <Layout>
                                <Venta />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/ventas" element={
                        <PrivateRoute>
                            <Layout>
                                <Ventas />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/venta/:id" element={
                        <PrivateRoute>
                            <Layout>
                                <DetalleVenta />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/vuelta" element={
                        <PrivateRoute>
                            <Layout>
                                <Vuelta />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/vueltas" element={
                        <PrivateRoute>
                            <Layout>
                                <Vueltas />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/complementar/:id" element={
                        <PrivateRoute>
                            <Layout>
                                <Complementar />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/liquidar-vueltas" element={
                        <PrivateRoute>
                            <Layout>
                                <LiquidarVueltas />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/cortes" element={
                        <PrivateRoute>
                            <Layout>
                                <Cortes />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/corte" element={
                        <PrivateRoute>
                            <Layout>
                                <Corte />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/gasto" element={
                        <PrivateRoute>
                            <Layout>
                                <Gasto />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/gastos" element={
                        <PrivateRoute>
                            <Layout>
                                <Gastos />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/asistencias" element={
                        <PrivateRoute>
                            <Layout>
                                <Asistencias />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/revision" element={
                        <PrivateRoute>
                            <Layout>
                                <Revision />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="/configuracion" element={
                        <PrivateRoute>
                            <Layout>
                                <Configuracion />
                            </Layout>
                        </PrivateRoute>
                    } />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
